<script lang="ts">
	import { AccountNavigator } from "../../AccountStore"
	import StorageController from "./Storage_Controller.svelte"
	import StorageGeneral from "./Storage_General.svelte"

	interface Props {
		isSubscriptionOpen?: boolean
	}

	let { isSubscriptionOpen = $bindable(false) }: Props = $props()
	AccountNavigator.subscribe((ctx) => (isSubscriptionOpen = ctx.props.openSubscription))
</script>

{#if isSubscriptionOpen}
	<StorageController />
{:else}
	<StorageGeneral />
{/if}

<style>
</style>
